.stubError {
  color: var(--stroke-orange);
}
